






































import {
  Component,
  Vue,
  Prop, Watch,
} from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { Application, Organisation } from '../types';
import ConfirmButton from '@/components/ConfirmButton.vue';

@Component({
  components: {
    ConfirmButton,
  },
})
export default class ApplicationEdit extends Vue {
  @Action private updateAdminApplicationAsync: any;
  @Action private createAdminApplicationAsync: any;
  @Action private addAdminDashboardsAsync: any;
  @Getter private applications!: object;
  @Getter private organisations!: object;
  @Getter private login: any;
  @Getter private availableDashboards: any;
  private applicationId: number | null = null;
  @Prop() private application: any;
  @Prop() private hideApplicationDrawer: any;

  private isSaving: boolean = false;
  private checkedOrgs: any[] = [];

  public mounted() {
    this.load();
  }

  public async save() {
    this.isSaving = true;
    try {
      const payload = {
        name: this.application.name,
        type: this.application.type,
        organisations: this.application.organisation_ids,
        reference: this.application.reference,
      };

      this.application.id
        ? await this.updateAdminApplicationAsync({ id: Number(this.application.id), payload })
        : await this.createAdminApplicationAsync(payload);

      this.$emit('close');
    } finally {
      this.isSaving = false;
      this.$emit('close');
    }
  }

  private async load() {
    const apiJobs: Array<Promise<void>> = [];
    apiJobs.push(this.$store.dispatch('addAdminDashboardsAsync'));
    await Promise.all(apiJobs);
  }

  @Watch('isSaving')
  private onSave() {
    this.$emit('save', this.isSaving);
  }

  @Watch('checkedOrgs')
  private onCheckOrg() {
    Vue.set(this.application, 'organisation_ids', this.checkedOrgs);
  }
}
